import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

type Product = {
  product_name: string;
  support_email: string;
  consent_text_version: string;
  consent_disclosure: string;
  app_env: string;
};

const fallback: Product = {
  product_name: "Remy",
  support_email: "",
  consent_text_version: "",
  consent_disclosure: "",
  app_env: "development",
};

const ProductContext = createContext<Product>(fallback);
export const useProduct = () => useContext(ProductContext);

export function ProductProvider({ children }: { children: React.ReactNode }) {
  const [product, setProduct] = useState<Product>(fallback);
  useEffect(() => {
    api.get("/config").then((r) => setProduct(r.data)).catch(() => {});
  }, []);
  return <ProductContext.Provider value={product}>{children}</ProductContext.Provider>;
}
